import Backbone from 'backbone';

import { reloadOnBackButton } from 'utils/window';

import PaymentMethods from 'app/models/payment_methods';

import Base from 'app/views/base';
import BankAccountButtonView from 'app/components/pages/billing/payment_methods/bank_account_button';
import CreditCardButtonView from 'app/components/pages/billing/payment_methods/credit_card_button';

import tmpl from './template';

export default Base.extend({
  compiledTemplate: tmpl,
  className: 'checkout',
  initialize({ user }) {
    this.model = new PaymentMethods({});
    this.listenTo(this.model, 'change', this.render);
    this.model.fetch();
    this.user = user;
    reloadOnBackButton();
  },
  beforeRender() {
    if (this.model.get('primary_payment_method')) {
      Backbone.history.navigate('/checkout/confirmation', { trigger: true, replace: true });
    }
    this.removeSubviews();
    this.addSubview(
      'creditCardButton', '.credit_card_button',
      new CreditCardButtonView({ model: this.model, priority: 'primary', user: this.user }),
    );
    this.addSubview(
      'bankAccountButton', '.bank_account_button',
      new BankAccountButtonView({ model: this.model, priority: 'primary', user: this.user }),
    );
  },
  context() {
    return {
      isPrimary: true,
    };
  },
});



// WEBPACK FOOTER //
// ./app/components/pages/checkout/billing/index.js